module.exports = {"view":"ansehen","edit":"bearbeiten","delete":"löschen"}